export const title = "404 error page";

export const content = {
  introLine:
    "Looks like you’ve found a link that no longer goes where it was supposed to... but don’t worry",
  headline: "Let’s get you back on track!"
};

export const links = [
  {
    heading: "Shop",
    items: [
      {
        label: "Makeup",
        href: {
          "en-GB": "/shop/makeup"
        }
      },
      {
        label: "Skincare",
        href: {
          "en-GB": "/shop/skincare"
        }
      },
      {
        label: "Fragrance",
        href: {
          "en-GB": "/shop/fragrances"
        }
      },
      {
        label: "Haircare",
        href: {
          "en-GB": "/shop/hair-care"
        }
      },
      {
        label: "Bodycare",
        href: {
          "en-GB": "/shop/body"
        }
      },
      {
        label: "Supplements",
        href: {
          "en-GB": "/shop/beauty-supplements"
        }
      }
    ]
  },
  {
    heading: "Top Pages",
    items: [
      {
        label: "My account",
        href: {
          "en-GB": "/login"
        }
      },
      {
        label: "The Beauty blog",
        href: {
          "en-GB": "/blog"
        }
      },
      {
        label: "Join Beauty Pie",
        href: {
          "en-GB": "/join-beauty-pie"
        }
      },
      {
        label: "How it works",
        href: {
          "en-GB":
            "https://beautypiehelp.zendesk.com/hc/en-gb/articles/360015856660-HOW-DOES-BEAUTY-PIE-WORK-",
          "en-US":
            "https://beautypiehelp-us.zendesk.com/hc/en-us/articles/360021483599-HOW-DOES-BEAUTY-PIE-WORK-"
        }
      },
      {
        label: "Members’ favourites",
        href: {
          "en-GB": "/shop/bestsellers"
        }
      },
      {
        label: "Gift memberships",
        href: {
          "en-GB": "/gift-memberships"
        }
      }
    ]
  },
  {
    heading: "Customer Care",
    items: [
      {
        label: "Delivery",
        href: {
          "en-GB":
            "https://beautypiehelp.zendesk.com/hc/en-gb/articles/5986781063442-DELIVERY-OPTIONS-AND-CHARGES"
        }
      },
      {
        label: "Returns",
        href: {
          "en-GB":
            "https://beautypiehelp.zendesk.com/hc/en-gb/articles/360014621880-CAN-I-RETURN-A-BEAUTY-PIE-ITEM-IF-I-DON-T-LIKE-IT"
        }
      },
      {
        label: "Refer a friend",
        href: {
          "en-GB": "/refer-a-friend"
        }
      },
      {
        label: "Payment methods",
        href: {
          "en-GB":
            "https://beautypiehelp.zendesk.com/hc/en-gb/articles/5987040238994-PAYMENT-METHODS?_ga=2.72635923.1470763432.1661153937-1276905422.1657107986",
          "en-US":
            "https://beautypiehelp-us.zendesk.com/hc/en-us/articles/5986973289618-PAYMENT-METHODS"
        }
      }
    ],
    colSpan: { base: 1, md: 2 }
  }
];
